/* eslint-disable */
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Autocomplete,
  Box,
  Typography,
  Divider,
  Paper,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { Icon } from '@iconify/react';




// ─── Main Component ──────────────────────────────────────────────────────────
export default function SaveWorkflowDialog({
  open,
  onClose,
  workflowName,
  setWorkflowName,
  onSave,
  selectedClient,
  setSelectedClient,
  handleSelectClient,
  clientData = [],
  location,
}) {


  const showClientField = location?.pathname === '/production2ndstep';



  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: 700,
          borderRadius: '16px',
          overflow: 'hidden',
          fontFamily: '"DM Sans", sans-serif',
          boxShadow: '0 25px 60px rgba(0,0,0,0.18)',
        },
      }}
    >
      {/* ── Header ── */}
      <Box sx={{ px: 3.5, pt: 3, pb: 2 }}>
        <Typography
          sx={{
            fontSize: '1.1rem',
            fontWeight: 700,
            color: '#111',
            fontFamily: '"DM Sans", sans-serif',
          }}
        >
          Save Workflow
        </Typography>
        <Typography
          sx={{
            fontSize: '0.8rem',
            color: '#9ca3af',
            fontFamily: '"DM Sans", sans-serif',
            mt: 0.25,
          }}
        >
          Define workflow properties and settings
        </Typography>
      </Box>

      <Divider sx={{ borderColor: '#f3f4f6' }} />

      {/* ── Body ── */}
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ display: 'flex' }}>

        

          {/* Right content */}
          <Box sx={{ flex: 1, px: 3.5, py: 3 }}>

         

            {/* Basic Info */}
            <Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <Icon icon="mdi:information-outline" width={15} color="#9ca3af" />
                <Typography
                  sx={{
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    color: '#9ca3af',
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    fontFamily: '"DM Sans", sans-serif',
                  }}
                >
                  Basic Info
                </Typography>
              </Box>

              <TextField
                label="Workflow Name"
                value={workflowName}
                onChange={(e) => setWorkflowName(e.target.value)}
                fullWidth
                autoFocus
                sx={{
                  mb: 2,
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    fontFamily: '"DM Sans", sans-serif',
                    fontSize: '0.875rem',
                    '&.Mui-focused fieldset': { borderColor: '#6366f1', borderWidth: '1.5px' },
                  },
                  '& .MuiInputLabel-root.Mui-focused': { color: '#6366f1' },
                  '& .MuiInputLabel-root': { fontFamily: '"DM Sans", sans-serif', fontSize: '0.875rem' },
                }}
              />

              {showClientField && (
                <Autocomplete
                  options={clientData}
                  getOptionLabel={(option) => option.name || ''}
                  value={selectedClient}
                  onChange={(event, newValue) => handleSelectClient(newValue)}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Client"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '10px',
                          fontFamily: '"DM Sans", sans-serif',
                          fontSize: '0.875rem',
                          '&.Mui-focused fieldset': { borderColor: '#6366f1', borderWidth: '1.5px' },
                        },
                        '& .MuiInputLabel-root.Mui-focused': { color: '#6366f1' },
                        '& .MuiInputLabel-root': { fontFamily: '"DM Sans", sans-serif', fontSize: '0.875rem' },
                      }}
                    />
                  )}
                />
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>

      <Divider sx={{ borderColor: '#f3f4f6' }} />

      {/* ── Footer ── */}
      <DialogActions
        sx={{
          px: 3.5,
          py: 2,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
    

        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: '10px',
              borderColor: '#e5e7eb',
              color: '#374151',
              fontFamily: '"DM Sans", sans-serif',
              fontWeight: 600,
              fontSize: '0.85rem',
              px: 2.5,
              textTransform: 'none',
              '&:hover': { borderColor: '#d1d5db', backgroundColor: '#f9fafb' },
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={onSave}
            variant="contained"
            disabled={!workflowName?.trim()}
            startIcon={<Icon icon="mdi:content-save-outline" width={17} />}
            sx={{
              borderRadius: '10px',
              backgroundColor: '#000000',
              fontFamily: '"DM Sans", sans-serif',
              fontWeight: 600,
              fontSize: '0.85rem',
              px: 2.5,
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': { backgroundColor: '#000000', boxShadow: 'none' },
              '&.Mui-disabled': { backgroundColor: '#e5e7eb', color: '#8997ae' },
            }}
          >
            Save Workflow
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}